import { connect } from 'react-redux'
import { selectors } from '../../store/modules/initial'
import withStateReadyCheck from '../../withStateReadyCheck'
import ModuleLoader from './ModuleLoader'

const { getModules, getZone } = selectors

const mapStateToProps = state => ({
  zone: getZone(state),
  moduleResults: getModules(state),
})

export default withStateReadyCheck(connect(mapStateToProps)(ModuleLoader))
